module.exports = __webpack_public_path__ + "img/icon10.70a26b30.png";